var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.99561C18 4.04561 13.95 -0.00439453 9 -0.00439453C4.05 -0.00439453 0 4.04561 0 8.99561C0 13.4956 3.2625 17.2081 7.5375 17.8831V11.5831H5.2875V8.99561H7.5375V6.97061C7.5375 4.72061 8.8875 3.48311 10.9125 3.48311C11.925 3.48311 12.9375 3.70811 12.9375 3.70811V5.95811H11.8125C10.6875 5.95811 10.35 6.63311 10.35 7.30811V8.99561H12.825L12.375 11.5831H10.2375V17.9956C14.7375 17.3206 18 13.4956 18 8.99561Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookBlack);
export default __webpack_public_path__ + "static/media/facebook-black.66cd2d4eee147a07d450346610cc3be5.svg";
export { ForwardRef as ReactComponent };